import { format, parseISO } from 'date-fns';

export const formatDate = (date: string | Date): string => {
    const d = typeof date === 'string' ? parseISO(date) : date;
    return format(d, 'dd-MM-yyyy');
};

export const formatDay = (date: string | Date): string => {
    const d = typeof date === 'string' ? parseISO(date) : date;
    return format(d, 'EEEE');
};

export const formatDateTime = (date: string | Date | number): string => {
    const d = typeof date === 'number' ? new Date(date) : typeof date === 'string' ? parseISO(date) : date;
    return format(d, 'dd-MM-yyyy HH:mm');
};

// Converts a plain `<input type="date">` value into the UTC instant bounding that day in the
// BROWSER's own timezone -- not the shop's, and not the server's (final-review F3: the server
// applies X-Timezone only to the day-end report's byHour buckets, never to the window itself --
// see the comment on PosService.getDayEndReport). A head-office user in a different timezone from
// the store gets a window shifted by the offset between them; a genuinely shop-local day boundary
// would need the server to apply it, which is future work, not something these client-side
// helpers can fix on their own.
//
// (final-review F5: previously duplicated verbatim in PosSaleList.tsx and PosDayEndReport.tsx,
// each with its own copy of this same caveat -- shared here instead of a third copy appearing.)
export const toDayStartIso = (dateStr: string): string => new Date(`${dateStr}T00:00:00`).toISOString();
export const toDayEndIso = (dateStr: string): string => new Date(`${dateStr}T23:59:59.999`).toISOString();
